const pickNumber = (...values) => {
  for (const value of values) {
    const n = Number(value);
    if (Number.isFinite(n)) return n;
  }
  return 0;
};

export const parseOperatorCommissionsRows = (payload) => {
  const rows = Array.isArray(payload)
    ? payload
    : payload?.data || payload?.operators || payload?.rows || [];

  if (!Array.isArray(rows)) return [];

  return rows.map((row, index) => ({
    _id: row?._id || `operator-${index}`,
    operator: row?.operator || "",
    particularServices: pickNumber(row?.particularServices),
    particularPay: pickNumber(row?.particularPay),
    batteryServices: pickNumber(row?.batteryServices),
    batteryPay: pickNumber(row?.batteryPay),
    addressVamnServices: pickNumber(row?.addressVamnServices),
    addressVamnPay: pickNumber(row?.addressVamnPay),
    totalPay: pickNumber(row?.totalPay),
  }));
};

export const formatCommissionMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "$0.00";
  return `$${n.toFixed(2)}`;
};
